import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import ThemableButton from "../../Items/ThemableButton"
import { green } from "@ant-design/colors"
import { faMoneyCheckDollar } from "@fortawesome/pro-duotone-svg-icons"
import { useContext } from "react"
import JobInvoicingContext from "../JobInvoicingContext"

type Props = {
  invoiceId: string
  disabled?: boolean
  onPayInvoice?: () => void
}

const PayInvoiceButton = ({ invoiceId, disabled, onPayInvoice }: Props) => {
  const { setActiveInvoicingModal } = useContext(JobInvoicingContext)
  return <ThemableButton
    type="primary"
    colorPrimary={green.primary}
    icon={<FontAwesomeIcon icon={faMoneyCheckDollar}/>}
    disabled={disabled}
    onClick={() => {
      setActiveInvoicingModal({ modal: 'payInvoice', invoiceId })
      onPayInvoice?.()
    }}
  >
    Pay Invoice
  </ThemableButton>
}

export default PayInvoiceButton